const ChevronsOpposing = () => (
  <>
    <path
      fill="currentColor"
      d="m12 16.208-2.746 2.746a.5.5 0 0 1-.344.15.47.47 0 0 1-.364-.15.5.5 0 0 1-.16-.354.5.5 0 0 1 .16-.354l2.889-2.888a.8.8 0 0 1 .267-.184.8.8 0 0 1 .298-.053.8.8 0 0 1 .298.053q.136.053.268.184l2.888 2.888a.5.5 0 0 1 .15.345.47.47 0 0 1-.15.363.5.5 0 0 1-.354.16.5.5 0 0 1-.354-.16zm0-8.416 2.746-2.746a.5.5 0 0 1 .345-.15.47.47 0 0 1 .363.15.5.5 0 0 1 .16.354.5.5 0 0 1-.16.354l-2.889 2.888a.8.8 0 0 1-.267.184.8.8 0 0 1-.298.053.8.8 0 0 1-.298-.053.8.8 0 0 1-.268-.184L8.547 5.754a.5.5 0 0 1-.15-.344.47.47 0 0 1 .15-.364.5.5 0 0 1 .354-.16.5.5 0 0 1 .354.16z"
    />
  </>
)
export default ChevronsOpposing
